import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ActivatedRoute, Params } from '@angular/router';
import { map } from 'rxjs/operators';
import { BaseHttpService } from '@nimbus-library/features/shared/services/base-http/base-http.service';
import { IAuthenticationService } from '@nimbus-library/features/authentication/services/i-authentication.service';
import { IPermissionManagerService } from '@nimbus-library/features/user-settings/services/contracts/i-permission-manager.service';
import { OrganizationUnitTypeEnum } from '@nimbus-global/features/shared/services/api/organization-unit/domain/organization-unit-type.enum';
import { IOrganizationUnitRawModel } from '@nimbus-global/features/shared/services/api/organization-unit/domain/i-organization-unit-raw.model';
import { IOrganizationUnitSelectListItemViewModel } from '@nimbus-global/features/shared/services/api/organization-unit/domain/i-organization-unit-select-list-item.view-model';
import { IOrganizationUnitDataService } from '@nimbus-global/features/shared/services/api/organization-unit/organization-unit-data.service';
import { ApiRoutes } from '@nimbus-admin/routing/api-routes.const';

@Injectable()
export class OrganizationUnitDataService extends IOrganizationUnitDataService {
  protected tenantId$: Observable<string>;

  public constructor(
    baseHttpService: BaseHttpService,
    authService: IAuthenticationService,
    permissionManagerService: IPermissionManagerService,
    private readonly activatedRoute: ActivatedRoute,
  ) {
    super(baseHttpService, authService, permissionManagerService);

    this.tenantId$ = this.activatedRoute.queryParams.pipe(
      map((queryParams: Params) => queryParams['tenantId'] || this.authService.getUserInfo().tenantId),
    );

    this.initialize();
  }

  public getTenantId(): string {
    return this.activatedRoute.snapshot.queryParams['tenantId'] || this.authService.getUserInfo().tenantId;
  }

  public getAllOrganizationUnitsByKind(kinds: OrganizationUnitTypeEnum): Observable<IOrganizationUnitRawModel[]> {
    return this.baseHttpService.get('organization-unit-manager/v2/all-kinds', { kinds });
  }

  /**
   * authorized-organization-units excludes Direct Call Handling teams unless the caller opts in - the
   * Admin Portal must administer those teams too (e.g. tab-visibility permission checks via
   * UserPermissionsService), so it opts in here. Portal doesn't, since regular users never manage services.
   */
  protected override query(tenantId: string): Observable<IOrganizationUnitSelectListItemViewModel[]> {
    return this.baseHttpService.get(ApiRoutes.Api.authorizedOrganizationUnitsPath, {
      tenantId,
      includeDirectCallServices: true,
    });
  }
}
